import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import CategoryGroup from './CategoryGroup';
import { SectionNames } from './PortalState/SectionDataMetaData';

const CategoryGroupPage = ({
    categoryGroupList,
    styles,
    imageLoading,
    imageType,
    uploadLogoFile,
    handleChange,
    onRemoveCategory,
    onCategoriesListEdit,
    onAddEntry,
    onDeleteEntry,
    errors }) => {

    const addANewEntry = () => {
        onAddEntry(SectionNames.categoryGroupsTab);
    }

    return (
        <><Grid item container xs={12} mt={3}>
            <Typography className={styles.textInputLabel}>
                Category Group
            </Typography>
        </Grid>
            <Grid
                mt={1}
                container
                direction="row"
                justifyContent={"space-between"}
                item
                xs={12}
                md={12}
                mb={2}
                sx={{ padding: "1.5rem 2rem" }}
            >
                {categoryGroupList.length === 0 ? (
                    <Typography sx={{ color: "#888", fontSize: "14px", fontFamily: "GilroyMedium", textAlign: "center", width: "100%", py: 2 }}>
                        No category groups added yet. Click "Add Group" to get started.
                    </Typography>
                ) : categoryGroupList.map((x, i) => {
                    return (
                        <CategoryGroup
                            key={i}
                            index={i}
                            data={x}
                            imageLoading={imageLoading}
                            imageType={imageType}
                            uploadLogoFile={uploadLogoFile}
                            handleChange={handleChange}
                            onDeleteEntry={onDeleteEntry}
                            styles={styles}
                            onRemoveCategory={onRemoveCategory}
                            onCategoriesListEdit={onCategoriesListEdit}
                            errors={errors}
                            isLast={i === categoryGroupList.length - 1}
                        />
                    );
                })}
            </Grid>
            <Grid container item xs={12} justifyContent={"flex-end"} mt={-1}>
                <Button
                    type="button"
                    disabled={false}
                    className={styles.addEntry}
                    onClick={addANewEntry}
                >
                    Add Group
                </Button>
            </Grid></>);
}

export default React.memo(CategoryGroupPage);
